
const getParam = (key:string):string => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(key) || ''
}

export default {
  getParam
}
